import React, { FC } from 'react';
import styles from './tooltip.module.scss';
import {
  NO_DATA,
  EMISSION_LABEL,
  FUEL_NAME_LABEL,
  PERCENTAGE_LABEL,
  UNIT,
  TARGET_LABEL,
  YEAR,
  CURRENT,
} from './constants';
import { formatValue } from 'shared/utils/formatWholeNum';
import { truncateWithEllipsis } from 'shared/utils/truncateWithElipsis';

interface CustomTooltipProps<T> {
  payload?: T;
  unit?: string;
  targetName?: string;
  isPie?: boolean;
  isPieSource?: boolean;
  isBar?: boolean;
  nameLabel?: string;
  valueLabel?: string;
}

interface PayloadData {
  totalCO2e?: number;
  year: number;
  percentage?: number;
  value?: number;
  fuelName?: string;
  locationName?: string;
  totalCO2?: number;
  targetCO2e?: number;
  emission?: number;
  name?: string;
}

const CustomTooltip: FC<CustomTooltipProps<PayloadData>> = ({
  payload,
  targetName,
  unit,
  isPie,
  isPieSource,
  isBar,
  nameLabel = FUEL_NAME_LABEL,
  valueLabel = EMISSION_LABEL,
}) => {
  if (!payload) return null;

  const {
    totalCO2e,
    targetCO2e,
    year,
    percentage,
    value,
    fuelName,
    locationName,
    totalCO2,
    emission,
    name,
  } = payload;

  return (
    <div className={styles.customTooltip}>
      {isBar ? (
        <div>
          {name && <div>{name}</div>}
          {locationName && <div>{locationName}</div>}

          <div>{`${valueLabel} ${formatValue(
            totalCO2 ?? emission
          )} ${unit ?? UNIT}`}</div>
        </div>
      ) : !isPie ? (
        <div>
          <div> {YEAR + year}</div>
          {totalCO2e !== undefined && (
            <div>{`${CURRENT} ${formatValue(totalCO2e)} ${
              unit || NO_DATA
            }`}</div>
          )}
          {targetCO2e !== undefined && (
            <div>
              {`${
                targetName && truncateWithEllipsis(targetName)
              } : ${formatValue(targetCO2e)} ${unit || NO_DATA}`}
            </div>
          )}
        </div>
      ) : (
        <div>
          <div>
            {isPieSource ? (
              <div>
                <div> {`${nameLabel} ${fuelName || NO_DATA}`}</div>
                <div>{`${valueLabel} ${formatValue(
                  totalCO2e
                )} ${unit ?? UNIT}`}</div>
              </div>
            ) : (
              `${valueLabel} ${formatValue(value)} ${unit ?? UNIT}`
            )}
          </div>
          <div>{`${PERCENTAGE_LABEL} ${
            percentage ? `${percentage} %` : NO_DATA
          }`}</div>
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
